import { render, staticRenderFns } from "./MatchChart.vue?vue&type=template&id=52aa0212&scoped=true&"
import script from "./MatchChart.vue?vue&type=script&lang=js&"
export * from "./MatchChart.vue?vue&type=script&lang=js&"
import style0 from "./MatchChart.vue?vue&type=style&index=0&id=52aa0212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa0212",
  null
  
)

export default component.exports